import { Component, ComponentNature, sceneComponent } from '@hatiolab/things-scene'
import MCSMachine from './mcs-machine'

const NATURE: ComponentNature = {
  mutable: false,
  resizable: true,
  rotatable: true,
  properties: [...MCSMachine.properties]
}

@sceneComponent('Equipment')
export default class Equipment extends MCSMachine {
  static get nature() {
    return NATURE
  }

  getLegendFallback() {
    return (this.root as any).equipmentLegendTheme || super.getLegendFallback()
  }

  containable(component: Component) {
    return super.containable(component) || ['Port'].includes(component.state.type)
  }
}
